<template>
  <div class="tab">
    <TabButton shopType="food" :show="$bus.inusefood" :discount="$bus.discount[0]" />
    <TabButton shopType="fishing" :show="$bus.inusefishing" :discount="$bus.discount[1]" />
    <TabButton shopType="shoot" :show="$bus.inuseshoot" :discount="$bus.discount[2]" />
  </div>
</template>

<script>
import TabButton from '@/components/business-base/tab-button'

export default {
  components: {
    TabButton
  }
}
</script>

<style lang="scss" scoped>
.tab {
  @include flexac;
  justify-content: space-between;
  position: absolute;
  @include px2res(bottom, 34);
  left: 50%;
  transform: translateX(-50%);
  @include px2res(width, 728);
  @include px2res(height, 85);
  @include px2res(padding, 0, 20);
}
</style>



// WEBPACK FOOTER //
// src/components/shop/tab.vue